import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

type AnalyticsNavigationTabsProps = {
  hospitalId?: string;
  className?: string;
};

const AnalyticsNavigationTabs: React.FC<AnalyticsNavigationTabsProps> = ({
  hospitalId,
  className = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!hospitalId) {
    return null;
  }

  const normalizedPath = location.pathname.toLowerCase();
  const analyticsPath = `/${hospitalId}/analytics`;
  const downloadCenterPath = `/${hospitalId}/downloadcenter`;
  const downloadCenterAltPath = `/${hospitalId}/download-center`;

  const tabs = [
    {
      key: "analytics",
      label: "Analytics",
      path: analyticsPath,
      isActive: normalizedPath.startsWith(analyticsPath.toLowerCase()),
    },
    {
      key: "download-center",
      label: "Download Center",
      path: downloadCenterPath,
      isActive:
        normalizedPath.startsWith(downloadCenterPath.toLowerCase()) ||
        normalizedPath.startsWith(downloadCenterAltPath.toLowerCase()),
    },
  ];

  return (
    <div
      className={`flex w-full bg-white rounded-xl border border-gray-200 overflow-hidden ${className}`}
    >
      {tabs.map(({ key, label, path, isActive }) => (
        <button
          key={key}
          type="button"
          aria-current={isActive ? "page" : undefined}
          onClick={() => {
            if (!isActive) {
              navigate(path);
            }
          }}
          className={`flex-1 basis-1/2 px-5 py-3 text-sm font-semibold transition-all ${
            isActive
              ? "bg-blue-50 text-blue-700 shadow-inner"
              : "bg-white text-gray-500 hover:bg-gray-50"
          } ${key === "analytics" ? "border-r border-gray-200" : ""}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default AnalyticsNavigationTabs;


